import * as React from 'react';
import { GlobalContext } from "../../Contexts/GlobalContext";
import DBService, { TABLE_TREES } from "../../Service/DBService";
// import { extractData } from "../../Helper/DebugHelper";
import * as ImageService from "../../Service/ImageService";

interface TestTreesState{
  iterations: 100;
  type: 1;
  picture?: number;
  message?: string;
  userId?: number;
  contractId?: number;
  loading: boolean;
}

export default class TestTrees extends React.Component<any, TestTreesState>{
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: any) {
    super(props);
    this.createTrees = this.createTrees.bind(this);
    this.updateTrees = this.updateTrees.bind(this);

    this.state = {
      message: undefined,
      iterations: 100,
      type: 1,
      picture: undefined,
      userId: 4,
      contractId: 1,
      loading: false,
    }
  }

  updateTrees(index: string, data: any) {
    this.setState({ ...this.state, ...{ [index]: data } })
  }

  async createTrees() {
    const { iterations, type, userId, contractId, picture } = this.state;

    this.setState({ loading: true });

    const formData = new FormData();

    const compressedFile = await ImageService.compressImage(picture, { maxSizeMB: 0.2 });
    formData.append('lng', "1");
    formData.append('lat', "1");
    formData.append('speed', "1");
    formData.append('accuracy', "1");
    formData.append('typeId', String(type));
    formData.append('number', "1");
    formData.append('userId', String(userId));
    formData.append('contractId', String(contractId));
    // formData.append('gpsHistory', '[]');
    formData.append('altitude_accuracy', "1");
    // formData.append('orientation', "1");
    formData.append('userAgent', '[]');
    formData.append('photo', compressedFile);

    for (let i = 0; i < iterations; i++) {
      this.setState({ message: `putting ${i+1} of ${iterations}` })
      // Convert FormData to object for IndexedDB storage
      const treeData: any = {};
      for (const [key, value] of (formData as any).entries()) {
        treeData[key] = value;
      }
      await DBService.putValue(TABLE_TREES, treeData);
    }

    this.setState({ loading: false });
  }

  render() {
    const { iterations, type, userId, contractId, loading, message } = this.state;

    return (
      <div style={{ padding: '20px', display: "block" }}>
        <div style={{ padding: '5px' }}>
          Iterations <input type="number" onChange={(e) => this.updateTrees('iterations', e.target.value )} value={iterations} />
        </div>
        <div style={{ padding: '5px' }}>
          Type <input type="number" onChange={(e) => this.updateTrees('type', e.target.value )} value={type} />
        </div>
        <div style={{ padding: '5px' }}>
          User ID <input type="number" onChange={(e) => this.updateTrees('userId', e.target.value)} value={userId} />
        </div>
        <div style={{ padding: '5px' }}>
          Contract ID <input type="number" onChange={(e) => this.updateTrees('contractId', e.target.value )} value={contractId} />
        </div>
        <div style={{ padding: '5px' }}>
          Picture <input type="file" accept="image/*" onChange={(e) => this.updateTrees("picture", e.target.files && e.target.files[0] )} />
        </div>
        <div style={{ padding: '5px' }}>
          {message && message}
        </div>
        <div style={{ padding: '5px' }}>
          <button onClick={this.createTrees} disabled={loading}>Create</button>
        </div>
      </div>
    );
  }
}